import React from 'react'
import connect from 'react-redux/es/connect/connect'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/Info'

import {workerJobsStopAll, workerJobsResumeAll, workerJobsResumeAllConfirm, changeDialogOpenState} from 'redux/admin/Actions'
import {DIALOG_NAME_RESUME_DURING_STUDENTS_CLEANUP} from 'redux/constants'
import {getRunningWorkerJobs, isStopAllWorkerJobsRequested} from 'common/model/WorkerJob'
import ConfirmationDialog from 'apps/admin/components/reusableComponents/ConfirmationDialog'

const warningStyle = {
  border: '2px solid #d32f2f',
  borderRadius: '8px',
  padding: '12px 16px',
  color: '#d32f2f',
  marginTop: '8px',
  marginBottom: '8px',
}

class WorkerJobsStopAllControl extends React.Component {
  render() {
    const {workerJobs, workerJobsStopAll, workerJobsResumeAll} = this.props

    if(!isStopAllWorkerJobsRequested(workerJobs)) {
      return (
        <div style={{display:'flex', alignItems:'center'}}>
          <Button onClick={workerJobsStopAll} color="secondary">
            Stop All Worker Jobs
          </Button>
          <Tooltip title="Asks every worker job to stop and keeps them from starting again, including scheduled runs. Jobs that are already running may take a moment to stop.">
            <InfoIcon color="action" style={{fontSize:20, marginLeft:4, cursor:'help'}}/>
          </Tooltip>
        </div>
      )
    }

    const runningCount = getRunningWorkerJobs(workerJobs).length

    if(runningCount === 0) return null

    return (
      <div style={{display:'flex', alignItems:'center'}}>
        <CircularProgress size={20} style={{marginRight:12}}/>
        <Typography variant="subtitle1">
          Stopping worker jobs... waiting for {runningCount} running {runningCount === 1 ? 'job' : 'jobs'} to finish.
        </Typography>
        <Button onClick={workerJobsResumeAll} color="secondary" style={{marginLeft:16}}>
          Cancel
        </Button>
      </div>
    )
  }
}

class WorkerJobsStoppedWarningClass extends React.Component {
  render() {
    const {workerJobs, workerJobsResumeAll} = this.props

    if(!isStopAllWorkerJobsRequested(workerJobs) || getRunningWorkerJobs(workerJobs).length > 0) return null

    return (
      <div style={{...warningStyle, display:'flex', alignItems:'center', justifyContent:'space-between'}}>
        <span>Warning: all worker jobs are stopped. No synchronization will run until worker jobs are re-enabled.</span>
        <Button onClick={workerJobsResumeAll} color="primary" style={{marginLeft:16, whiteSpace:'nowrap'}}>
          Re-enable Worker Jobs
        </Button>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  workerJobs: state.admin.workerJobs,
})

const mapDispatchToProps = {
  workerJobsStopAll,
  workerJobsResumeAll,
}

export const WorkerJobsStoppedWarning = connect(mapStateToProps, mapDispatchToProps)(WorkerJobsStoppedWarningClass)

// opened by the resume all saga when a students data cleanup is in progress
const ResumeDuringStudentsCleanupDialogComponent = ({isOpen, workerJobsResumeAllConfirm, changeDialogOpenState}) => (
  <ConfirmationDialog
    open={isOpen}
    onClose={() => changeDialogOpenState({dialogName: DIALOG_NAME_RESUME_DURING_STUDENTS_CLEANUP, isOpen: false})}
    onConfirm={workerJobsResumeAllConfirm}
    title="Students data cleanup is in progress"
    contentPrimary="Worker jobs were stopped for a students data cleanup and will be re-enabled automatically once it is complete."
    contentSecondary={'Re-enabling them now lets synchronization run while students data is being deleted.\nPlease wait until the cleanup is complete. Re-enable worker jobs anyway?'}
  />
)

export const ResumeDuringStudentsCleanupDialog = connect(
  state => ({isOpen: !!state.admin.dialogs[DIALOG_NAME_RESUME_DURING_STUDENTS_CLEANUP]}),
  {workerJobsResumeAllConfirm, changeDialogOpenState},
)(ResumeDuringStudentsCleanupDialogComponent)

export default connect(mapStateToProps, mapDispatchToProps)(WorkerJobsStopAllControl)
